export const TianMapKeysArr:string[] = [
  '5d04dce9373d880fc559efeb546d84fa',
  'dbacabc903eb25430e0d075e6a888132',
  'c56e9961d8a23caceb5669263073acfb',
  'fd8217e2ffecec7fae2fe7db84db3c1a'
]
export const TianMapKeys = {
  /** 天地图鉴权key */
  tk: TianMapKeysArr[Math.floor(Math.random() * TianMapKeysArr.length)],
}
export const tdtUrl = 'https://t{s}.tianditu.gov.cn/'
// 注意: {s} 会被替换为 SUBDOMAINS 数组中的随机子域名，确保图层加载时正确使用子域名
export const SUBDOMAINS = ['0', '1', '2', '3', '4', '5', '6', '7']
